import { useApiUtils } from 'x1-base/composables';
import { useCustomFetch } from '~/composables';
import type { SetupIntentResponse } from '~/types';
import type { NitroFetchOptions } from 'nitropack';

export function useSetupIntent() {
    const apiBasePath = `/v1/setup-intents`;
    const useApiUtilsObj = useApiUtils();
    const $_fetch = useCustomFetch();


    async function getSetupIntent(): Promise<SetupIntentResponse | Error> {
        const url = `${apiBasePath}/`;
        const config: NitroFetchOptions<string> = {
            method: 'POST'
        };

        try {
            return await $_fetch<SetupIntentResponse>(url, config);
        } catch (err) {
            return useApiUtilsObj.getErrorObj(err);
        }
    }
    
    return {
        getSetupIntent
    };
}
